import React from 'react';
import { TabelaCampanhas } from '../../components/TabelaCampanhas';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';


export default function CampanhasPage() {

  return (
    <div className="p-pt-0">
      <MenuMain >
        <TabelaCampanhas />
      </MenuMain>
      <AppFooter />
    </div>
  );
}